import { StatusChip as BaseStatusChip, ResultContainer as BaseResultContainer, EstablishmentCard as BaseEstablishmentCard, StyledCard as BaseStyledCard } from "../styled";

export const StyledCard = BaseStyledCard;
export const StatusChip = BaseStatusChip;
export const ResultContainer = BaseResultContainer;
export const EstablishmentCard = BaseEstablishmentCard;
